import { type OperationId, operationIds } from "@gen/app-access-config";

import { ActionFormWithDescription } from "./ActionFormWithDescription";
import { useSubmitComplaintMutation } from "./useSubmitComplaintMutation";

interface SubmitComplaintActionProps {
  canExecuteForStatus: (operationId: OperationId) => boolean;
  isF2f?: boolean;
  transactionId: number;
}

export function SubmitComplaintAction({
  canExecuteForStatus,
  isF2f,
  transactionId,
}: SubmitComplaintActionProps) {
  const { submitComplaint, isLoading } = useSubmitComplaintMutation({
    transactionId: transactionId,
    isF2f: !!isF2f,
  });

  const canExecute = canExecuteForStatus(
    isF2f
      ? operationIds["core_admin.submitF2fComplaint"]
      : operationIds["core_admin.submitOnlineComplaint"],
  );

  return (
    <ActionFormWithDescription
      title="Submit Complaint"
      buttonText="Submit complaint"
      canExecute={canExecute}
      isLoading={isLoading}
      onSubmit={submitComplaint}
      dataTestId="submit-complaint"
    />
  );
}
